import React from "react";
import "../App.css";

const CryptoPopup = ({ show, onYes, onNo }) => {
  return (
    <div className={`crypto-popup-overlay ${show ? "active" : ""}`}>
      <div className="crypto-popup-content">
        <div className="crypto-popup-header">
          <span className="crypto-popup-icon" aria-hidden>
            ✨
          </span>
          <h2 className="crypto-popup-title">Want to earn real money?</h2>
        </div>
        <div className="crypto-popup-body">
          <p className="crypto-popup-text">
            Join our main platform for more games and a chance to earn real
            money while you play.
          </p>
          <ul className="crypto-popup-bullets">
            <li>Get Upto 320% Deposit Bonus</li>
            <li>Fast payouts and secure play</li>
            <li>No kyc needed</li>
            <li>Instant withdrawals</li>
            <li>24/7 support</li>
            <li>New games added every week</li>
          </ul>
        </div>
        <div className="crypto-popup-buttons">
          <button type="button" className="crypto-btn-yes" onClick={onYes}>
            Yes, take me there
          </button>
          <button type="button" className="crypto-btn-no" onClick={onNo}>
            Stay here
          </button>
        </div>
      </div>
    </div>
  );
};

export default CryptoPopup;
